export const shareTeleopDeviceIdKey = "shareTeleop.deviceId";
